import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithErrorHandling } from '@/services/baseApi';

// 票券狀態枚舉 (已簡化)
export enum TicketStatus {
    UNVERIFIED = 'UNVERIFIED', // 未核銷
    VERIFIED = 'VERIFIED',     // 已核銷
    VOID = 'VOID',             // 已作廢
}

// 票券數據接口
export interface Ticket {
    id: string;
    ticketNo: string;
    orderNo: string;
    productName: string;
    customerName: string;
    customerPhone?: string | undefined;
    amount: number;
    status: TicketStatus;
    // validUntil: string; // Removed per compliance
    createdAt: string;

    // New fields
    cost: number;
    sellingPrice: number;
    productStatus: string;
    faceValue: number;
    originalPrice: number;
    contractNo: string;
    serviceDuration: string;
    expiryDate: string; // 優惠到期日
    notes?: string | undefined;

    // Verification Info
    verifiedAt?: string | undefined;     // 核銷時間
    verifiedByShop?: string | undefined; // 核銷店家 (包含品牌)
    verifiedByStaff?: string | undefined; // 核銷人員

    // Void Info
    voidedAt?: string | undefined;       // 作廢時間
    voidedBy?: string | undefined;       // 作廢人員



    purchasedAt?: string | undefined;    // 購買時間 (通常等於 createdAt)
    trustNo?: string | undefined;        // 信託號碼
}

// 響應接口
export interface TicketsResponse {
    success: boolean;
    data: {
        tickets: Ticket[];
        total: number;
        page: number;
        pageSize: number;
    };
}

// 查詢參數接口
export interface TicketsParams {
    page?: number;
    pageSize?: number;
    keyword?: string | undefined; // 搜尋票券編號或訂單編號
    status?: TicketStatus | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    shopName?: string | undefined; // 核銷店家名稱
}

// 定義 Ticket API Slice
export const ticketApi = createApi({
    reducerPath: 'ticketApi',
    baseQuery: baseQueryWithErrorHandling,
    tagTypes: ['Ticket'],
    endpoints: (builder) => ({
        getTickets: builder.query<TicketsResponse, TicketsParams>({
            query: (params) => ({
                url: '/tickets',
                params,
            }),
            providesTags: ['Ticket'],
        }),
        getTicketById: builder.query<Ticket, string>({
            query: (id) => `/tickets/${id}`,
            providesTags: (_result, _error, id) => [{ type: 'Ticket', id }],
        }),
        updateTicketStatus: builder.mutation<Ticket, { id: string; status: TicketStatus; reason: string }>({
            query: ({ id, status, reason }) => ({
                url: `/tickets/${id}/status`,
                method: 'POST',
                body: { status, reason },
            }),
            invalidatesTags: (_result, _error, { id }) => [{ type: 'Ticket', id }, 'Ticket'],
        }),
    }),
});

export const { useGetTicketsQuery, useGetTicketByIdQuery, useUpdateTicketStatusMutation } = ticketApi;
